import HomeCard from '../../components/HomeCard/HomeCard'
import './HomePage.css'
import { Container } from "react-bootstrap"

const HomePage = () => {

    return (

        <HomeCard />

    )
}

export default HomePage
